import React, {useState} from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';
import earth from '../img/header/earth.png'
import { useNavigate } from "react-router-dom";



const OpenCalls = () => {

  const [activeCalls, setActiveCalls] = useState("upcoming")
  const navigate = useNavigate();


  return (
  <>
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto'
    >
     <div className=' h2 lg:px-40 lg:pt-0 pt-28 text-center lg:text-start lg:pb-10'>
     </div>

     <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='overflow-auto flex  border-zinc-900 items-center justify-center mt-10'
    >
     <div className='flex items-center justify-center border-2 border-zinc-900 text-center w-fit rounded-lg p-3 lg:mt-20'>
      <div onClick={() => setActiveCalls("upcoming")} className={`h6 lg:h5 px-10 hover:text-black hover:cursor-pointer  ${activeCalls == "upcoming" ? 'text-black' : 'text-gray-400'}`}>
      Upcoming
      </div>
      <div onClick={() => setActiveCalls("past")} className={`h6 lg:h5 px-10 hover:text-black hover:cursor-pointer  ${activeCalls == "past" ? 'text-black' : 'text-gray-400'}`}>
      Past
      </div>
     </div>
     </motion.section>
     <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}>
     {activeCalls === "past" && (
      <>
       
      <div className='flex lg:flex-col items-center align-middle pt-10 lg:pt-0 lg:py-8 justify-center'>
     </div>
     <div className='lg:px-60 lg:flex-row flex-col items-center flex lg:justify-between lg:pb-10 '>
       <div className='flex lg:block lg:items-start lg:justify-center flex-col items-center justify-center'>
        <h2 className='lg:text-3xl lg:mb-4 font-bold lg:text-start text-center'>Earth Day</h2>
        <p className='w-3/4 text-sm lg:text-start text-center'>Discover a sanctuary for healing and transformation, 
where wellness meets movement for a balanced, vibrant life.
        </p>

       </div> 
       <div className='lg:w-[200px] w-[100px] lg:flex hidden hover:scale-110'>
       </div>

     </div>
     <div className='lg:px-60 pt-10 lg:pt-0 lg:flex-row flex-col items-center flex lg:justify-between lg:pb-20 '>
       <div className='flex lg:block lg:items-start lg:justify-center flex-col items-center justify-center'>
        <h2 className='lg:text-3xl lg:mb-4 font-bold lg:text-start text-center'>International Day for the <br/> Elimination of Violence Against Women</h2>
        <p className='w-3/4 text-sm lg:text-start text-center'>Discover a sanctuary for healing and transformation, 
where wellness meets movement for a balanced, vibrant life.
        </p>

       </div> 
       <div className='lg:w-[200px] w-[100px] lg:flex hidden hover:scale-110'>
       </div>
    
     </div>
     </>)}
     {activeCalls === "upcoming" && (
      <>
      <div className='flex lg:flex-col items-center align-middle pt-10 lg:pt-0 lg:py-8 justify-center'>
      
     </div>
      <div className='flex items-center justify-center'>
        {/* <h2 className='lg:h4  px-10 lg:px-0 text-center h5 text-gray-500 py-10 lg:py-20'>Upcoming open calls will be announced shortly</h2> */}
        <div className='lg:px-60 lg:flex-row flex-col items-center flex lg:justify-between lg:pb-10 '>
       <div className='flex lg:block lg:items-start lg:justify-center flex-col items-center justify-center'>
        <h2 className='lg:text-3xl lg:mb-4 font-bold lg:text-start text-center'>Second Life Project</h2>
        <p className='w-3/4 text-sm lg:text-start text-center mb-8'>
        The Second Life Project is a residency dedicated to honoring the invisible labor of women in India’s waste systems. We invite Indian and international artists, designers, community workers, and changemakers to join us in creating new, hopeful narratives around dignity, gender, and circular living.
        </p>
        <a        target="_blank"
                  rel="noreferrer"
                  href='https://docs.google.com/forms/d/e/1FAIpQLSf7P91B_4q-ReKNItVFdlA_COk90wEH3y5FEHI2jLN0UlpLaA/viewform'
                  className=" border-2 border-black hover:scale-110 hover:bg-zinc-900 hover:text-white w-fit p-4 hover:cursor-pointer"
                >
                  Apply
                </a>
       </div> 
       <div className='lg:w-[200px] w-[100px] lg:flex hidden hover:scale-110'>
       </div>

     </div>
      </div>
      </>
     )}
     </motion.section>
     
    </motion.section>
    </>
  )
}

export default OpenCalls